/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { AddToPendingList } from '../../../terminal/shared/model/terminal-pending.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { EditModeService } from '../../../core/services/edit-mode.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { LocoIncident } from '../../../core/model/loco-incident.model';
import { LocoIncidentDetails } from '../../../core/model/loco-incident-details.model';
import { LocoIncidentService } from '../../../core/services/loco-incident-service';
import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { PopupService } from '../../../core/services/popup.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { TabService } from '../../../core/services/tab.service';
import { TrainDataService } from '../../../train/services/train-data.service';
import { environment } from './../../../../environments/environment';
import { UserService } from '../../../core/services/user.service';

/**
 * @export
 * @class LmsLocoContextMenuComponent
 * @implements {OnDestroy}
 * @implements {AfterViewInit}
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-loco-context-menu',
  templateUrl: './lms-loco-context-menu.component.html',
  styleUrls: ['./lms-loco-context-menu.component.scss']
})
export class LmsLocoContextMenuComponent implements OnDestroy, AfterViewInit, OnInit, OnChanges {
  formatDateOnly(dateStr: string): string {
    return this.appUtilService.formatDateOnly(dateStr);
  }

  @Input() screenName: string;
  /**
   * This field is used to store the details of Locomotive
   * for which we are going to display the details in context panel
   * @type {LocoDetail}
   * @memberOf LmsLocoContextMenuComponent
   */
  @Input() loco: LocoDetail;

  /**
   * This field is used to store the id of svg html element
   * for displaying the context panel with respect to this element
   * @type {*}
   * @memberOf LmsLocoContextMenuComponent
   */
  @Input() locoId: any;

  @Input() currentTerminal: string;

  @Input() locoStatusOpr: any;
  @Input() addToPendingList: Array<AddToPendingList>;


  operationData: any = {};

  cancelPlanEnable: boolean;

  rightPanlePosition: string;

  /**
   * this field is used to get the labels from configService
   * @type {*}
   * @memberOf LmsLocoContextMenuComponent
   */
  locoLabel: any;

  /**
   * this field is used to give position from left to left side panel of context panel
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  panelLeftPosX: string;

  /**
   * this field is used to give position from top to left side panel of context panel
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  panelLeftPosY: string;

  /**
   * this field is used to give position from left to right side panel of context panel
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  panelRightPosX: string;

  /**
   * this field is used to give position from top to right side panel of context panel
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  panelRightPosY: string;

  /**
   * this field is used to store the height of window on which application is running.
   * @type {number}
   * @memberOf LmsLocoContextMenuComponent
   */
  windowHeight: number;

  /**
   * this field is used to store the width of window on which application is running.
   * @type {number}
   * @memberOf LmsLocoContextMenuComponent
   */
  windowWidth: number;

  /**
   * this field is used to store the scroll hight of page
   * @type {number}
   * @memberOf LmsLocoContextMenuComponent
   */
  scrollHeight: number;

  /**
   * this field is used to provide dynamic width to
   * panel containing links to data, profile, history etc.
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  leftWidth: string;

  /**
   * this field is used to apply dynamic height to
   * panel containing links to data, profile, history etc.
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  leftHeight: string;

  /**
   * this fields states the hight of left side panel
   * that contains the menu items like data, history etc.
   * @memberOf LmsLocoContextMenuComponent
   */
  leftMenuHeight = 137;

  /**
   * this fields states the width of left side panel
   * that contains the menu items like data, history etc.
   * @memberOf LmsLocoContextMenuComponent
   */
  leftMenuWidth = 107;

  /**
   * this fields states the hight of right side panel
   * that contains the details of a locomotive.
   * @memberOf LmsLocoContextMenuComponent
   */
  rightPanelHeight = 515;

  /**
   * this fields states the width of right side panel
   * that contains the details of a locomotive.
   * @memberOf LmsLocoContextMenuComponent
   */
  readonly rightPanelWidth = 350;

  /**
   * this field states the width of left side navigation panel
   * which is used when we position the context panel
   * @memberOf LmsLocoContextMenuComponent
   */
  readonly leftNavWidth = 50;

  /**
   * this field states the height of top header panel
   * which is used when we position the context panel
   * @memberOf LmsLocoContextMenuComponent
   */
  topHeaderHeight = 70;

  isLinkDisable: boolean;

  /**
   * @type {boolean}
   * @memberOf LmsLocoContextMenuComponent
   */
  @Input() isUpdateTHP: boolean;

  @Input() windowCode: string;

  /**
   * @type {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  contentPanelVisible: string;

  @Output() updateTHPEvent: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();

  trainDataServiceSubscription: any;
  @Input() isLocoStatusScreen: boolean;
  @Input() isYardLocalScreen: boolean;
  isAllocateBtnEnabled: boolean;
  isDeAllocateBtnEnabled: boolean;
  @Input() isTrainDataScreen: boolean;
  @Input() isTerminalStatusScreen: boolean;

  thpVisibility: boolean;
  thpDisable: boolean;
  showHeader: boolean;
  /**
   * Creates an instance of LmsLocoContextMenuComponent.
   * and inject the services like configService and lmsModuleService
   * @param {ConfigService} configService
   * @param {LmsModuleService} lmsModuleService
   * @memberOf LmsLocoContextMenuComponent
   */
  constructor(private configService: ConfigService,
    private lmsModuleService: LmsModuleService,
    private staticDataStoreService: StaticDataStoreService,
    private router: Router,
    private popupService: PopupService,
    private trainDataService: TrainDataService,
    private editModeService: EditModeService,
    public appUtilService: AppUtilityService,
    private messageHandlerService: MessageHandlerService,
    private tabService: TabService,
    private lmsLoaderService: LmsLoaderService,
    private locoIncidentService: LocoIncidentService, 
    public user: UserService) {
    this.trainDataServiceSubscription = this.trainDataService.loadData.subscribe((data) => {
      this.operationData = data;
    });
    this.locoLabel = this.configService.getConfigData().locoLabel;
    this.contentPanelVisible = 'hidden';

    if(staticDataStoreService.getValue('SHOW_HEADER') == false)
        this.showHeader = false;
    else
        this.showHeader = true;
  }

  /**
   * this method is used to set the values to default
   * so that we can recalculate for every context panel
   * @private
   * @memberOf LmsLocoContextMenuComponent
   */
  private setDefaultValues() {
    this.leftWidth = '';
    this.leftHeight = '';
    this.leftMenuHeight = 195;
    this.leftMenuWidth = 107;
  }

  /**
   * this method is used to set the scroll position back to top
   * this case occured when user switch between context panel
   * of multiple locomotives
   * @private
   * @memberOf LmsLocoContextMenuComponent
   */
  private changeScrollPosition() {
    const rightPanel = document.getElementById('contextPanelID');
    if (rightPanel) {
      rightPanel.scrollTop = 0;
    }
  }

  /**
   * this method is used to prepare the the context menu penal
   * this method also take care of position of context menu
   * on page.
   * @private
   * @returns
   * @memberOf LmsLocoContextMenuComponent
   */
  private prepareContextPanel() {
    let mySvg;
    this.setDefaultValues();
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;
    this.scrollHeight = window.pageYOffset;
    if (this.locoStatusOpr === undefined || this.locoStatusOpr.headerName === undefined) {
      mySvg = document.getElementById(this.locoId);
    } else {
      mySvg = document.querySelectorAll("[locoMixId='"+ this.loco.trainLocoMixId +"']")[0];
    }
    let rect: any;
    if (mySvg) {
      rect = mySvg.getBoundingClientRect();
    } else {
      if (this.loco) {
        this.loco.renderContextMenu = false;
      }
      return;
    }
    const rightPanel = document.getElementById('contextPanelID');
    let leftPanel = document.getElementById('locomotiveBriefLeftMenu');
    if (rightPanel) {
      const rightRect = rightPanel.getBoundingClientRect();
      this.rightPanelHeight = rightRect.height;
    }
    if (leftPanel) {
      const leftElem = leftPanel.getBoundingClientRect();
      this.leftMenuHeight = leftElem.height;
      this.leftMenuWidth = leftElem.width;
    }

    if (rect.width !== this.leftMenuWidth) {
      this.leftMenuWidth = rect.width;
      this.leftWidth = rect.width + 'px';
    } else {
      this.leftWidth = this.leftMenuWidth + 'px';
      this.leftHeight = this.leftMenuHeight + 'px';
    }

    const elementTop = rect.top;
    const elementLeft = rect.left;
    const leftAvailable = elementLeft;
    const rightAvailable = this.windowWidth - elementLeft - rect.width;
    const lowerAvailable = this.windowHeight - elementTop - rect.height;
    const upperAvailable = elementTop;
    if (this.isLocoStatusScreen || this.isYardLocalScreen) {
      this.topHeaderHeight = 36;
    }
    setTimeout(() => {
      leftPanel = document.getElementById('locomotiveBriefLeftMenu');
      this.scrollHeight = window.pageYOffset;
      const oldvalue = this.leftMenuHeight;
      this.leftMenuHeight = leftPanel.scrollHeight;
      this.leftHeight = this.leftMenuHeight + 'px';
      const diff = Math.abs(oldvalue - this.leftMenuHeight);
      let heightAdjust = 0;
      if (this.scrollHeight > 67) {
        heightAdjust = 70;
      }
      if (lowerAvailable > this.rightPanelHeight) {
        this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
      } else {
        if (!(lowerAvailable > upperAvailable)) {
          if (this.rightPanlePosition && this.rightPanlePosition !== 'top') {
            this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
          } else {
            this.panelLeftPosY = this.scrollHeight + elementTop - this.leftMenuHeight - this.topHeaderHeight + 'px';
          }
        } else {
          this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight - heightAdjust + 'px';
        }
      }
    }, 5);

    if (this.rightPanelWidth < rightAvailable) {
      this.panelRightPosX = elementLeft - this.leftNavWidth + rect.width + 'px';
      if ((lowerAvailable) > this.rightPanelHeight) {
        this.panelRightPosY = this.scrollHeight + elementTop - this.topHeaderHeight + 'px';
        this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
        this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
        this.rightPanlePosition = 'down';
      } else if (upperAvailable > this.rightPanelHeight) {
        this.panelRightPosY = this.scrollHeight + elementTop - this.rightPanelHeight - this.topHeaderHeight + rect.height + 'px';
        this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
        this.panelLeftPosY = this.scrollHeight + elementTop - this.leftMenuHeight - this.topHeaderHeight + 'px';
        this.rightPanlePosition = 'top';
      } else {
        const difference = this.windowHeight - this.rightPanelHeight;
        this.panelRightPosY = this.scrollHeight + 'px';
        if (lowerAvailable > upperAvailable) {
          this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
          this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
          this.rightPanlePosition = 'down';
        } else {
          this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
          this.panelLeftPosY = this.scrollHeight + elementTop - this.leftMenuHeight - this.topHeaderHeight + 'px';
          this.rightPanlePosition = 'top';
        }
      }
    } else {
      this.panelRightPosX = elementLeft - this.rightPanelWidth - this.leftNavWidth + 'px';
      if ((lowerAvailable) > this.rightPanelHeight) {
        this.panelRightPosY = this.scrollHeight + elementTop - this.topHeaderHeight + 'px';
        this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
        this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
        this.rightPanlePosition = 'down';
      } else if (upperAvailable > this.rightPanelHeight) {
        this.panelRightPosY = this.scrollHeight + elementTop - this.rightPanelHeight - this.topHeaderHeight + rect.height + 'px';
        this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
        this.panelLeftPosY = this.scrollHeight + elementTop - this.leftMenuHeight - this.topHeaderHeight + 'px';
        this.rightPanlePosition = 'top';
      } else {
        const difference = this.windowHeight - this.rightPanelHeight;
        this.panelRightPosY = this.scrollHeight + 'px';
        if (lowerAvailable > upperAvailable) {
          this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
          this.panelLeftPosY = this.scrollHeight + elementTop + rect.height - this.topHeaderHeight + 'px';
          this.rightPanlePosition = 'down';
        } else {
          this.panelLeftPosX = elementLeft - this.leftNavWidth + 'px';
          this.panelLeftPosY = this.scrollHeight + elementTop - this.leftMenuHeight - this.topHeaderHeight + 'px';
          this.rightPanlePosition = 'top';
        }
      }
    }
    this.changeScrollPosition();
    this.contentPanelVisible = 'visible';
    this.cancelPlanEnable = this.loco && this.loco.locomotiveIdentifier
      && this.loco.locomotiveIdentifier.toUpperCase() !== 'ZZZZZZZZZZZZZZ'
      && this.appUtilService.isPlannedLoco(this.loco);
  }

  /**
   * @memberOf LmsLocoContextMenuComponent
   */
  ngOnInit() {
  }

  /**
   * When any changes occured in above data of this Locomotive
   * this method is basically used to position the Locomotive
   * context menu with respect to a Locomotive on which right click occurs
   * @memberOf LmsLocoContextMenuComponent
   */
  ngOnChanges() {
    if (this.loco && this.loco.tripPlans) {
      this.loco.tripPlans = this.loco.tripPlans.filter((data) => { return data.trim().length > 0; });
    }
    if (!this.operationData) {
      if (!this.locoStatusOpr) {
        this.locoStatusOpr = {};
      }
      this.operationData = this.locoStatusOpr;
      if (this.locoStatusOpr && this.locoStatusOpr.header) {
        if (this.locoStatusOpr.header === 'OUTBOUND' || this.locoStatusOpr.header === 'IN READY FIELD'
          || this.locoStatusOpr.header === 'AT SERVICE CENTER' || this.locoStatusOpr.header === 'NET ALLOCATION' || this.locoStatusOpr.header === 'DUE OUT SHOP' || this.locoStatusOpr.header === 'ON PIT' || this.locoStatusOpr.header === 'STORED') {
          this.thpVisibility = false;
        } else {
          this.thpVisibility = true;
          this.thpDisable = (this.loco.thpType && this.loco.thpText) ? false : true;
        }
      } else {
        this.thpVisibility = true;
      }
    } else {
      if (this.locoStatusOpr && this.locoStatusOpr.header) {
        if (this.locoStatusOpr.header === 'OUTBOUND' || this.locoStatusOpr.header === 'IN READY FIELD'
          || this.locoStatusOpr.header === 'AT SERVICE CENTER' || this.locoStatusOpr.header === 'NET ALLOCATION' || this.locoStatusOpr.header === 'DUE OUT SHOP' || this.locoStatusOpr.header === 'ON PIT' || this.locoStatusOpr.header === 'STORED') {
          this.thpVisibility = false;
        } else {
          this.thpVisibility = true;
          this.thpDisable = (this.loco.thpType && this.loco.thpText) ? false : true;
        }
      } else {
        this.thpVisibility = true;
      }
    }
    if (!this.isTerminalStatusScreen && this.editModeService.isEditMode) {
      this.isLinkDisable = true;
    } else {
      this.isLinkDisable = false;
    }
    if (this.loco) {
      this.loco = this.appUtilService.getFeaturesFromPicklist(this.loco);
      if (this.loco.listOfFeature && this.loco.listOfFeature.length > 8) {
        this.loco.listOfFeature = this.loco.listOfFeature.slice(0, 8);
      }
    }
    this.checkForAllocateDeAllocate();
  }

  ngAfterViewInit() {
    setTimeout(() => { this.prepareContextPanel(); }, 5);
  }

  /**
   * @memberOf LmsLocoContextMenuComponent
   */
  ngOnDestroy() {
    this.trainDataServiceSubscription.unsubscribe();
  }

  getPlannedAssignmentValue() {
    let returnVal = '';
    if (this.loco && this.appUtilService.isPlannedLoco(this.loco)) {
      const planValue = this.getPlannedAssignmentLocation();
      if (planValue === 'TRAIN') {
        let plannedLocation = this.loco.plannedOrCurrentLoc;
        if (!plannedLocation) {
          plannedLocation = this.loco.plannedLocation;
        }
        returnVal = this.loco.plannedOrCurrentAssign;
        if (plannedLocation && plannedLocation !== undefined && plannedLocation !== 'undefined') {
          returnVal += ' at ' + plannedLocation;
        }
      } else if (planValue === 'FOREIGNROAD') {
        let plannedLocation = this.loco.plannedOrCurrentLoc;
        if (!plannedLocation) {
          plannedLocation = this.loco.plannedLocation;
        }
        if (plannedLocation) {
          returnVal = plannedLocation;
        }
        if (this.loco.plannedOrCurrentAssign) {
          returnVal += ' at ' + this.loco.plannedOrCurrentAssign;
        }
      } else if (planValue === 'TERMINAL') {
        returnVal = this.loco.plannedOrCurrentAssign;
      }
    }
    return returnVal && returnVal.length > 0 ? returnVal : '-';
  }
  private getPlannedAssignmentLocation(): string {
    let returnValue = '';
    if (this.appUtilService.isValidTrainId(this.loco.plannedOrCurrentAssign)) {
      returnValue = 'TRAIN';
    } else if (this.appUtilService.isMnemonicExist(this.loco.plannedOrCurrentAssign)) {
      if (this.loco.plannedOrCurrentLoc || this.loco.plannedLocation) {
        returnValue = 'FOREIGNROAD';
      } else {
        returnValue = 'TERMINAL';
      }
    }

    return returnValue;
  }

  /**
   * this method is used to navigate the user to locomotive screen
   * depends on user's click whether it is Data or Profile or Notes
   * @param {string} subType
   * @param {string} type
   * @memberOf LmsLocoContextMenuComponent
   */
  public showLocomotiveTabData(subType: string, type: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: this.formatLocomotiveId(this.loco.locomotiveIdentifier) });

    //open brand window with locomotive
    if((subType.toLowerCase() === 'data' && type.toLowerCase() === 'locomotive') || subType.toLowerCase() === 'notes' || subType.toLowerCase() === 'history')
    {
      window.open(
        window.location.href.split('?')[0] + '?type=locomotive&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
          '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
        );
    }
    //open tab inside the window open with locomotive
    else
    {
      this.appUtilService.navigateByUrl(type, subType, tabSearchParameter.searchText, true);
    }
  }


  /**
   * This method returns dash only when all the values given are null or blank
   * @param {string[]} value
   * @returns
   * @memberOf LmsLocoContextMenuComponent
   */
  public returnDash(value: string[]) {
    return this.appUtilService.checkMultipleBlankStatus(value);
  }

  /**
   * Format the locomotive id
   * @private
   * @param {string} value
   * @returns {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  formatLocomotiveId(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
   * Emits event for show update terminal handling plan popup.
   * @param {LocoDetail} looc
   * @memberOf LmsLocoContextMenuComponent
   */
  showUpdateTHPPopup() {
    // this.updateTHPEvent.emit(this.loco);
    const operation = {
      currentTerminal: this.currentTerminal,
      operation: 'UpdateThp',
      locomotive: this.loco,
      windowCode: this.windowCode,
      screenName: this.screenName,
      mainLocodata: [this.loco],
      addToPendingList: this.addToPendingList

    };
    this.popupService.setPopupOperation(operation);
  }

  cancelLocomotivePlan() {
    if (this.loco && this.operationData) {
      const select = {
        rowID: '',
        locomotiveID: this.formatLocomotiveIdForRequest(this.loco.locomotiveIdentifier),
        assignedPlannedFlag: this.loco.assignedPlannedFlag,
        qualifier: this.loco.qualifier
      };
      const locos = [];
      locos.push(select);
      const request = {
        thpTerminal: '',
        terminalHandlingType: '',
        trainId: this.operationData.trainIdentifier,
        otherLocosList: locos
      };
      let currentTerminalId;
      if (this.isLocoStatusScreen) {
        currentTerminalId = '      ';
      } else {
        currentTerminalId = this.operationData.currentTerminal;
      }
      const operation = {
        operation: 'CancelLocomotivePlan',
        data: request,
        currentTerminal: currentTerminalId,
        windowCode: this.windowCode,
        mainLocodata: [this.loco],
        addToPendingList: this.addToPendingList,
        screenName: this.screenName
      };
      this.popupService.setPopupOperation(operation);

    } else {
      return;
    }
  }

  /**
   * @private
   * @param {string} value
   * @returns {string}
   *
   * @memberOf LmsLocoContextMenuComponent
   */
  private formatLocomotiveIdForRequest(value: string): string {
    let formattedValue = value;
    if (value) {
      value = value.trim();
      if (this.isNumeric(value.charAt(0))) {
      } else {
        const v = value.match(/\d+/);
        if (v) {
          const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
          const locoNumber = (v.index <= 4) ?
            value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();

          if (this.isNumeric(locoNumber)) {
            formattedValue = this.rightPad(locoInitial, ' ', 4) + '    ' + this.leftPad(locoNumber, '0', 6);
          }
        }
      }
    }
    return formattedValue;
  }

  /**
   * @param {string} value
   * @returns {boolean}
   *
   * @memberOf LmsLocoContextMenuComponent
   */
  public isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   *
   * @memberOf LmsLocoContextMenuComponent
   */
  leftPad(str, padString, max): string {
    str = str.toString();
    return str.length < max ? this.leftPad(padString + str, padString, max) : str;
  }

  /**
   * @private
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   *
   * @memberOf LmsLocoContextMenuComponent
   */
  private rightPad(str, padString, max): string {
    str = str.toString();
    return str.length < max ? this.rightPad(str + padString, padString, max) : str;
  }

  /**
   * Locate Locomotive according to Assignment
   * @memberOf LmsLocoContextMenuComponent
   */
  locateLocomotive() {
    if (this.loco.locoAllocStation.trim().length > 0) {
      this.redirectToYardAndLocal(this.loco.locoAllocDiv, this.loco.locoAllocStation, this.loco.locoAllocType);
    } else {
      if ('MW' === this.loco.permanentTag.toUpperCase().trim() && 0 === this.loco.locoAllocStation.trim().length) {
        this.redirectToYardAndLocal('ALLMOW', 'all', 'M');
      } else {
        if ('I' === this.loco.qualifier.toUpperCase()
          || 'E' === this.loco.qualifier.toUpperCase() || 'O' === this.loco.qualifier.toUpperCase()) {
          this.showTrainTabData('Data', 'Train', this.loco.currentAssignment, this.appUtilService.UIformatLocomotiveId(this.loco.locomotiveIdentifier));
        } else if ('S' === this.loco.qualifier.toUpperCase()
          || 'W' === this.loco.qualifier.toUpperCase() || 'Y' === this.loco.qualifier.toUpperCase()) {
          this.appUtilService.navigateByUrl('locomotive', 'data', this.appUtilService.UIformatLocomotiveId(this.loco.locomotiveIdentifier), true);
        } else if ('V' === this.loco.qualifier.toUpperCase()) {
          this.redirectToYardAndLocal(this.loco.currentAssignment, 'all', 'A');
        } else {
          this.showTerminalTabData('Status', 'Terminal', this.loco.currentAssignment, this.appUtilService.UIformatLocomotiveId(this.loco.locomotiveIdentifier));
        }
      }
    }
  }

  /**
    * Redirect to yard and local screen.
    * @memberof LmsLocoContextMenuComponent
    */
  redirectToYardAndLocal(division?: string, allocationStation?: string, allocationType?: string) {
    if (this.loco) {
      if (this.tabService.isTabRedirectionAllowed('yard-local', 'data')) {
        const yarLocalRouteParams = `division=${division}&allocationStation=${allocationStation}&allocationType=${allocationType}&locomotiveId=${this.loco.locomotiveIdentifier}`;
        this.router.navigateByUrl(`/yard-local/data/${new Date().getTime()}?${yarLocalRouteParams}`,
          { skipLocationChange: environment.hideUrl });
      } else {
        this.messageHandlerService.handleMessage(<MessageDetails>({
          type: this.configService.getConfigData().message.type.client,
          level: this.configService.getConfigData().message.level.error,
          target: this.configService.getConfigData().message.target.page,
          message: this.configService.getConfigData().messages.maxTab
        }));
      }
    }
  }
  /**
  * this method is used to navigate the user to locomotive screen
  * depends on user's click whether it is Data or Profile or Notes
  * @param {string} subType
  * @param {string} type
  * @memberOf LmsLocoContextMenuComponent
  */
  public showTerminalTabData(subType: string, type: string, currentAssignment, locateLocoId: string) {
    this.appUtilService.locate(type, subType, currentAssignment, locateLocoId);
  }

  /**
  * Default Enter to Yard And Local
  * @memberOf LmsLocoContextMenuComponent
  */
  setDefaultEnterToYardAndLocal() {
    this.popupService.setPageMode('Dialog');
    this.popupService.setSubmitBtnId('yardAndLocalLocoData');
  }

  /**
   * Locate Loco to Train
   * @param {string} subType
   * @param {string} type
   * @param {string} trainIdentifier
   * @memberOf LmsLocoContextMenuComponent
   */
  public showTrainTabData(subType: string, type: string, trainIdentifier: string, locateLocoId: string) {
    this.appUtilService.locate(type.toLowerCase(), subType.toLowerCase(), trainIdentifier, locateLocoId);
  }

  /**
   * @memberOf LmsLocoContextMenuComponent
   */
  showYardAndLocalPop() {
    const operation = {
      currentTerminal: this.currentTerminal,
      operation: 'locateYardAndLocal',
      locomotive: this.loco,
      windowCode: this.windowCode,
      screenName: this.screenName
    };
    this.popupService.setPopupOperation(operation);
  }

  allocateLocomotive() {
    const operation = {
      operation: 'allocateLocomotive',
      data: this.loco
    };
    this.popupService.setPopupOperation(operation);
  }

  deAllocateLocomotive() {
    const operation = {
      operation: 'deAllocateLocomotive',
      data: this.loco
    };
    this.popupService.setPopupOperation(operation);
  }

  allocateTerminalLocomotive() {
    const operation = {
      operation: 'AllocateLocomotives',
      data: [this.loco],
      windowCode: 'LWTW'
    };
    this.popupService.setPopupOperation(operation);
  }

  deAllocateTerminalLocomotive() {
    const operation = {
      operation: 'DeallocateLocomotives',
      data: [this.loco],
      windowCode: 'LWTW'
    };
    this.popupService.setPopupOperation(operation);
  }

  /**
   * Check for state of allocate and de-allocate buttons.
   * @memberof LmsLocoContextMenuComponent
   */
  checkForAllocateDeAllocate() {
    if (this.loco) {
      if (this.loco.allocateRole && (this.loco.allocateRole === 'YL' || this.loco.allocateRole === 'MW')) {
        if (this.loco.locoAllocStation && this.loco.locoAllocStation.trim().length === 0) {
          this.isAllocateBtnEnabled = true;
          this.isDeAllocateBtnEnabled = false;
        } else {
          this.isAllocateBtnEnabled = false;
          this.isDeAllocateBtnEnabled = true;
        }
      } else {
        this.isAllocateBtnEnabled = false;
        this.isDeAllocateBtnEnabled = false;
      }
    }
  }

  getThpTypeInformation(type: string, text: string) {
    if (text) {
      return text;
    } else if (type) {
      return type;
    } else {
      return '';
    }
  }

  isLocoPlannedToTrain() {
    if (this.loco && (this.loco.plannedOrCurrentAssign && this.appUtilService.isValidTrainId(this.loco.plannedOrCurrentAssign))) {
      return true;
    } else {
      return false;
    }
  }

  isUpdateIntendedUsage() {
    if (this.loco && (this.loco.intendedUsageCode || this.isLocoPlannedToTrain())) {
      return true;
    } else {
      return false;
    }
  }

  updateIntendedUsage() {
    this.lmsLoaderService.showLoader();
    const locoIdArr: Array<string> = [];
    if (this.loco && this.loco.deadFlag && this.loco.deadFlag.trim().toUpperCase() === 'Y') {
      this.loco.locoIncident = 'OOS';
    } else if (this.loco && this.loco.locomotiveIdentifier) {
      locoIdArr.push(this.appUtilService.getFormattedIncidentLocoId(this.loco.locomotiveIdentifier));
    }
    if (locoIdArr && locoIdArr.length > 0) {
      this.locoIncidentService.getData(locoIdArr).subscribe((data: any) => {
        this.lmsLoaderService.hideLoader();
        if (data && data.locoIncidentList) {
          const locoIncidentDetails: LocoIncidentDetails = data;
          if (locoIncidentDetails && locoIncidentDetails.locoIncidentList.length > 0) {
            for (let i = 0; i < locoIncidentDetails.locoIncidentList.length; i++) {
              const locoIncident: LocoIncident = locoIncidentDetails.locoIncidentList[i];
              if (locoIncident) {
                if (locoIncident.problemcode.trim().toUpperCase() === 'TRF') {
                  this.loco.locoIncident = 'TRF';
                }
              }
            }
          }
        } else {
          this.lmsLoaderService.hideLoader();
          this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configService.getConfigData().message.type.client,
            level: this.configService.getConfigData().message.level.error,
            target: this.configService.getConfigData().message.target.page,
            message: 'Internal Server Error'
          }));
        }
        if (!this.loco.locoIncident || this.loco.locoIncident.trim().length === 0) {
          if (this.loco && this.loco.axles.trim() === '6') {
            this.loco.locoIncident = '6-ax';
          } else if (this.loco && this.loco.axles.trim() === '4') {
            this.loco.locoIncident = '4-ax';
          }
        }
        const operation = {
          currentTerminal: this.currentTerminal,
          operation: 'IntendedUsage',
          data: this.loco,
        };
        this.popupService.setPopupOperation(operation);
      },
        error => {
          this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configService.getConfigData().message.type.client,
            level: this.configService.getConfigData().message.level.error,
            target: this.configService.getConfigData().message.target.page,
            message: 'Internal Server Error'
          }));
        }
      );
    } else {
      this.lmsLoaderService.hideLoader();
      const operation = {
        currentTerminal: this.currentTerminal,
        operation: 'IntendedUsage',
        data: this.loco,
      };
      this.popupService.setPopupOperation(operation);
    }
  }

  getIntendedUsageReasonValue(code: string) {
    let codeValue = '';
    if (code) {
      codeValue = this.appUtilService.getIntendedUsageReasonDesc(code);
    }
    return codeValue;
  }
}
